<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <template v-if="comunicado?.tipo === 2">
                <b-col cols="12" class="mb-3">
                    <Button @click="showModal('como-funciona')">¿Cómo funciona?</Button>
                </b-col>
                <ModalComponent
                    name="como-funciona"
                    title="¿Cómo funciona?"
                    @close="closeModal('como-funciona')"
                >
                    <h4>
                        Para crear las plantillas que podréis seleccionar desde el selector de más abajo, se crean desde el siguiente enlace
                        <router-link :to="{ name: 'back.plantillas-whatsapp.crear' }" target="_blank" class="blue">
                            <span>Crear plantillas</span>
                        </router-link>.
                    </h4>
                    <h4>Una vez ahí, rellenarás los datos del formulario y verás una vista prevía a la derecha de cómo va quedando el mensaje que se enviará por WhatsApp, al igual que la ves justo debajo del selector de la plantilla.</h4>
                </ModalComponent>
            </template>
            <b-col cols="12" class="mb-2">
                <div class="form-group">
                    <label for="tipo-comunicado">Selecciona el tipo de comunicado:</label>
                    <ValidationProvider name="tipo-comunicado" rules="required" v-slot="{ errors }">
                        <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="tipo-comunicado" v-model="comunicado.tipo">
                            <option :value="0" selected>Selecciona el tipo de comunicado</option>
                            <option :value="1">Email</option>
                            <option :value="2">WhatsApp</option>
                        </select>
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col v-if="comunicado.tipo > 0" cols="12">
                <FormEmail v-if="comunicado.tipo == 1" :comunicado="comunicado" :loading.sync="loading" />
                <FormWhatsapp v-else-if="comunicado.tipo == 2" :comunicado="comunicado" :loading.sync="loading" />

                <b-col cols="12" class="text-right mt-3 pr-0">
                    <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
                </b-col>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    import FormEmail from '@/components/backend/comunicados/tipo-comunicado/FormEmail.vue';
    import FormWhatsapp from '@/components/backend/comunicados/tipo-comunicado/FormWhatsapp.vue';
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            comunicado: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                
                if(isValid) {
                    if (this.comunicado.whatsapp_template) {
                        this.comunicado.whatsapp_template_id = this.comunicado.whatsapp_template.id;
                        delete this.comunicado.whatsapp_template;
                    }

                    if (!this.comunicado.whatsapp_template_id) {
                        delete this.comunicado.whatsapp_template_id;
                    }

                    if (this.comunicado.base) {
                        this.comunicado.base_id = this.comunicado.base.id;
                        delete this.comunicado.base;
                    }

                    this.$emit('terminado');
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
        },
        created() {
            if(this.comunicado.listo_para_enviar) {
                this.comunicado.listo_para_enviar = 1;
            } else {
                this.comunicado.listo_para_enviar = 0;
            }
        },
        components: {
            FormEmail, FormWhatsapp, ModalComponent
        }
    }
</script>
